import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Scissors, Lock, Spinner, WarningCircle } from '@phosphor-icons/react';

export const LoginPage = () => {
  const { login } = useAuth();
  const [loginStr, setLoginStr] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loginStr.trim() || !password.trim()) return;
    setLoading(true);
    setError('');
    try {
      await login(loginStr, password);
    } catch (err) {
      setError(err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#F7F6F4] flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#1B4332' }}>
            <Scissors size={32} weight="bold" className="text-white" />
          </div>
          <h1 className="text-3xl font-bold text-[#18181B]" style={{ fontFamily: 'Outfit' }}>
            Salon<span style={{ color: '#1B4332' }}>Up</span>
          </h1>
          <p className="text-sm text-[#71717A] mt-1">Sistema operacional do salao moderno</p>
        </div>

        <div className="bg-white rounded-3xl border border-[#E4E4E7] p-8 shadow-sm">
          <div className="flex items-center gap-2 mb-6">
            <Lock size={18} weight="regular" className="text-[#A1A1AA]" />
            <h2 className="text-lg font-semibold text-[#18181B]" style={{ fontFamily: 'Outfit' }}>Entrar</h2>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-[10px] font-medium text-[#71717A] uppercase tracking-wide mb-1">Login</label>
              <input data-testid="input-login" type="text" value={loginStr}
                onChange={(e) => setLoginStr(e.target.value)} placeholder="Seu login" autoFocus autoComplete="username"
                className="w-full px-3 py-2.5 bg-[#F7F6F4] border border-[#E4E4E7] rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#1B4332]/20" />
            </div>
            <div>
              <label className="block text-[10px] font-medium text-[#71717A] uppercase tracking-wide mb-1">Senha</label>
              <input data-testid="input-password" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="Sua senha" autoComplete="current-password"
                className="w-full px-3 py-2.5 bg-[#F7F6F4] border border-[#E4E4E7] rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#1B4332]/20" />
            </div>

            {error && (
              <div className="flex items-center gap-1.5 text-red-500" data-testid="login-error">
                <WarningCircle size={14} weight="fill" />
                <span className="text-xs font-medium">{error}</span>
              </div>
            )}

            <button type="submit" disabled={loading || !loginStr.trim() || !password.trim()}
              data-testid="btn-login"
              className="w-full py-2.5 rounded-xl text-sm font-medium text-white flex items-center justify-center gap-2 disabled:opacity-60 transition-all hover:shadow-lg"
              style={{ backgroundColor: '#1B4332' }}>
              {loading ? <Spinner size={16} className="animate-spin" /> : null}
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        </div>

        <p className="text-center text-[10px] text-[#A1A1AA] mt-6">
          SalonUp &middot; Gestao (CORE)
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
